import { z } from 'zod';

import type { GroupWithPermissions } from '@/modules/groups';
import type { MessageKey } from '@/modules/localizations/translations/types';
import type { WhitelistUser } from '@/modules/whitelist';

import { VaultFormField } from '../constants';

/**
 * Members are held in the record-sharing permission shape, because the form reuses the record-sharing
 * member rows. They are converted to vault roles at the form boundary — see `vaultFormValues`.
 *
 * No maximum name length: neither the contract nor the equivalent record-name field sets one.
 */
export const vaultFormSchema = z.object({
    [VaultFormField.NAME]: z
        .string()
        .trim()
        .min(1, { message: 'form.error.required' satisfies MessageKey }),
    [VaultFormField.GROUPS]: z.array(z.custom<GroupWithPermissions>()),
    [VaultFormField.USERS]: z.array(z.custom<WhitelistUser>()),
});

export type VaultFormSchemaType = typeof vaultFormSchema;

export type VaultFormValues = z.infer<typeof vaultFormSchema>;
